const t = "styles-module__sectionedForm___D8hah", e = "styles-module__title___KcjlL", s = "styles-module__section___ijMFo", _ = "styles-module__sectionTitle___-LCRz", o = "styles-module__available___IauTY", l = "styles-module__sectionTitleText___en4nK", c = "styles-module__complete___QSo4e", n = "styles-module__caret___nXcTB", i = "styles-module__submitButton___-enqD", m = {
  sectionedForm: t,
  title: e,
  section: s,
  sectionTitle: _,
  available: o,
  sectionTitleText: l,
  complete: c,
  caret: n,
  submitButton: i
};
export {
  o as available,
  n as caret,
  c as complete,
  m as default,
  s as section,
  _ as sectionTitle,
  l as sectionTitleText,
  t as sectionedForm,
  i as submitButton,
  e as title
};
